module.exports = __webpack_public_path__ + "static/img/SV.bdca3d8d.svg";